import { createFileRoute } from '@tanstack/react-router';

import { TravelRegistryBrowse } from '@/module/Travel/Registry/TravelRegistryBrowse';

export const Route = createFileRoute('/_auth/travel/_travel/registry/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TravelRegistryBrowse />;
}
